export default __webpack_public_path__ + "static/media/zeiss_cc_18.12.2014_g6465.83c62b36.jpg";